export default "__VITE_ASSET__5ad8ed2c__"